// cleanup_convert_to_typescript_file_CREATE_RECURRING_TRANSFERS

import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import Modal, { TYPES } from '@glu/modal-react';
import { ExclamationCircleIcon } from '@glu/icons-react';

import useLocale from 'components/useLocale/useLocale';
import { PAYMENT_ACTIONS, URL_PARAM_ACTIONS } from 'constants.js';

import useStyles from './recurringTransferModal.styles';

const { VIEW } = URL_PARAM_ACTIONS;

export const RecurringTransferCancelModal = ({ action, onClose, opened }) => {
  const { icon, message, modal, modalDialog, root, warningTitle } = useStyles();
  const locale = useLocale();
  const { action: pageAction } = useParams();

  const modalTitle =
    action === PAYMENT_ACTIONS.MODIFY_TEMPLATE
      ? locale['common.unsavedChanges']
      : locale['create.payment.back'];

  return (
    <section className={root}>
      <Modal
        classes={{
          card: modalDialog
        }}
        dataQa="recurring-transfer-cancel"
        open={opened}
        type={TYPES.ERROR}
        onClose={onClose}
        btnPrimaryText={locale['common.leave']}
        btnPrimaryAttributes={{ 'data-qa': 'leave', className: 'btn btn-primary' }}
        onBtnPrimaryClick={action}
        btnTertiaryText={locale['common.cancel']}
        btnTertiaryAttributes={{ 'data-qa': 'cancel', className: 'btn btn-tertiary' }}
        onBtnTertiaryClick={onClose}
        closeOnClickAway={false}
      >
        <section className={modal}>
          <div className={icon}>
            <ExclamationCircleIcon aria-hidden title="warning" focusable="false" />
          </div>
          <h3 className={warningTitle}>{modalTitle}</h3>
          <p className={message}>
            {locale['create.payment.back.confirm']}
            {pageAction !== VIEW && <p>{locale['create.payment.back.confirm.line2']}</p>}
          </p>
        </section>
      </Modal>
    </section>
  );
};

RecurringTransferCancelModal.defaultProps = {
  opened: false,
  onClose() {},
  action: ''
};

RecurringTransferCancelModal.propTypes = {
  opened: PropTypes.bool,
  onClose: PropTypes.func,
  action: PropTypes.string
};

export default RecurringTransferCancelModal;
